export var SearchInputVariants;
(function (SearchInputVariants) {
    SearchInputVariants["primary"] = "primary";
    SearchInputVariants["secondary"] = "secondary";
})(SearchInputVariants || (SearchInputVariants = {}));
//# sourceMappingURL=constants.js.map